<template>
  <!-- 透明度控制 -->
  <div :class="['tool-btn', { show: isHidden }]" id="opacity-slider" class="opacity-control-container">
    <span style="font-size: 0.467rem; color: white; margin-bottom: 0.167rem; opacity: 0.9;">
      Line Opacity: {{ String(lineOpacityCoef) + '%' }}
    </span>
    <el-slider v-model="lineOpacityCoef" show-tooltip="false" :step="opacitySettingPath" :min="0"
               style="width: 5.33rem; height: 0.5rem"/>

    <span style="font-size: 0.467rem; color: white; margin-bottom: 0.167rem; margin-top: 0.524rem; opacity: 0.9;">
      Label Font Size: {{ String(labelFontScale) + 'x' }}
    </span>
    <el-slider v-model="labelFontScale" show-tooltip="false" :step="0.1" :min="0.5" :max="2"
               style="width: 5.33rem; height: 0.5rem"/>
  </div>
<!--  ont-size: 14px; color: white; margin-bottom: 5px;-->
  <!-- 放大缩小自适应视图 -->
  <div :class="['about-btn', { show: isHidden }]" id="graph-fixer" style="position:absolute;left: 0.267rem;bottom: 0;width: 1.33rem;height: 4rem;">
    <ul class="tool-bar">
      <li @click="zoomIn">
        <img src="zoomIn.svg" class="tool-img">
      </li>
      <li @click="zoomOut">
        <img src="zoomOut.svg" class="tool-img">
      </li>
      <li @click="fitTheView">
        <img src="fitTheView.svg" class="tool-img">
      </li>
    </ul>
  </div>
</template>


<script setup>
import {
  myGraph,
  state,
  calcDistFromOrig,
  formData,
  lineOpacityCoef,
  labelFontScale,
} from '../stores/globalStore';
import {getLinkThreeObject} from '../stores/globalStore';
import {watch} from 'vue';
import {cameraFramePadding, opacitySettingPath} from "@/configs/graphConfig";


defineProps({
  isHidden: {
    type: Boolean,
    default: false
  }
})


// 4.4 连线透明度控制
watch(lineOpacityCoef, () => {
  myGraph.linkThreeObject(link => {
    return getLinkThreeObject(link, formData.minThreshold, lineOpacityCoef.value / 200, false);
  })
})

/**
 * ZoomIn
 */
// 6.3 图形操作
// 6.3.1 放大按钮
function zoomIn() {

  let origPos = myGraph.cameraPosition();
  let newPos = myGraph.cameraPosition();
  let origLookAt = myGraph.cameraPosition().lookAt;
  let fixLookAt = {x: 0, y: 0, z: 0};

  newPos.x = newPos.x - (origPos.x - origLookAt.x) * 0.1;
  newPos.y = newPos.y - (origPos.y - origLookAt.y) * 0.1;
  newPos.z = newPos.z - (origPos.z - origLookAt.z) * 0.1;

  myGraph.cameraPosition(
      newPos, // new position
      fixLookAt,
      500  // ms transition duration
  );
  state.labelNeedUpdateVisibility = 1;
}

/**
 * ZoomOut
 */
// 6.3.2 缩小按钮
function zoomOut() {
  let origPos = myGraph.cameraPosition();
  let newPos = myGraph.cameraPosition();
  let origLookAt = myGraph.cameraPosition().lookAt;
  let fixLookAt = {x: 0, y: 0, z: 0};

  console.log("Origin: ")
  console.log(origLookAt)
  newPos.x = newPos.x + (origPos.x - origLookAt.x) * 0.1;
  newPos.y = newPos.y + (origPos.y - origLookAt.y) * 0.1;
  newPos.z = newPos.z + (origPos.z - origLookAt.z) * 0.1;

  myGraph.cameraPosition(
      newPos, // new position
      fixLookAt,
      500  // ms transition duration
  );
  state.labelNeedUpdateVisibility = 1;
}

/**
 * Auto fit the view
 * With animation and set label that state.labelNeedUpdateVisibility
 */
// 6.3.3 自适应按钮(回到初始位置)
function fitTheView() {
  let camera = myGraph.cameraPosition();
  myGraph.zoomToFit(600, cameraFramePadding, (node) => (node.category !== 'colorgroup'));
  state.labelNeedUpdateVisibility = 1;
  setTimeout(() => {
    state.cameraOrigDist = calcDistFromOrig(camera.x, camera.y, camera.z);
    state.labelNeedUpdateVisibility = 1;
  }, 605)
}

</script>

<style>
.tool-btn {
  /* 隐藏时位移到屏幕外 */
  transform: translateX(-6.67rem);
  transition: transform 0.3s ease;
}

.tool-btn.show {
  transform: translateX(0);
}

.opacity-control-container {
  position: absolute;
  left: 0.267rem;
  top: 0.5rem;
  width: 6rem;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(135deg, rgba(32, 33, 36, 0.95), rgba(66, 70, 77, 0.95));
  backdrop-filter: blur(10px);
  border-radius: 0.267rem;
  box-shadow: 0 0.133rem 0.5rem rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 5.167rem 0.33rem 0.4rem;
}

.tool-img {
  margin: 0.033rem;
  height: 0.8rem;
  width: 0.8rem;
  opacity: 0.8;
  filter: invert(1) brightness(0.9);
  transition: all 0.2s ease;
}

.tool-img:hover {
  opacity: 1;
  filter: invert(1) brightness(1);
  transform: scale(1.1);
}

.tool-bar {
  z-index: 2000;
  position: absolute;
  list-style-type: none;
  padding: 0.133rem;
  background: linear-gradient(135deg, rgba(32, 33, 36, 0.95), rgba(66, 70, 77, 0.95));
  backdrop-filter: blur(10px);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.0667rem;
}

.tool-bar li {
  width: 0.93rem;
  height: 0.93rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  list-style: none;
  border-radius: 0.133rem;
  transition: background-color 0.2s ease;
}

.tool-bar li:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.el-slider__runway {
  height: 0.2rem;
}

.el-slider__button {
  width: 0.8rem;
  height: 0.8rem;
}



</style>